import type {Context} from '../types';
import type {JSONNode} from '@packages/shared/types/JSONNode';
import {Type} from '@packages/systems/wfdl';

const someFieldWithoutBindUIVariant = (
  dataType: Type | string | Record<any, any>
) => {
  if (typeof dataType !== 'string' && 'fields' in dataType) {
    for (const fieldId in dataType.fields) {
      const field = dataType.fields[fieldId];
      if (field && field.system && !field.system.bindUIVariant) {
        return true;
      }
    }
  }
  return false;
};

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}, dataType = {}} = jsonNode as JSONNode;
  const isSymbolRoot = data.sym && data.sym.root === true;
  const hasFieldsWithoutBindUIVariant =
    typeof dataType !== 'string' &&
    'fields' in dataType &&
    someFieldWithoutBindUIVariant(dataType);

  return {
    needed: Boolean(isSymbolRoot && hasFieldsWithoutBindUIVariant),
    logData: {
      msg: 'Symbol fields should have bindUIVariant set to "dot-with-label" ',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (typeof dataType !== 'string' && 'fields' in dataType) {
        const fields = (dataType as {fields: Record<string, any>}).fields;
        for (const fieldId in fields) {
          const field = fields[fieldId];
          if (field && field.system && !field.system.bindUIVariant) {
            field.system.bindUIVariant = 'dot-with-label';
          }
        }
      }
    },
  };
};
